import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import T from 'mrf/utils/T';
import path from "path";
import {
    StyledAccordion,
    StyledAccordionButton,
    StyledAccordionItems,
    StyledAccordionLink,
    StyledAccordionIcon,
} from "styles/components/Accordion.styles";
import Flex from "mrf/layout/Flex";
import { generateHtmlId } from "mrf/utils/StringGenerators";
import IFAuth from 'mrf/view/IFAuth.js';

Accordion.propTypes = {
    match: PropTypes.object,
    title: PropTypes.string.isRequired,
    subItems: PropTypes.arrayOf(PropTypes.object),
};

function Accordion({ match, title, subItems }) {
    const [active, setActive] = useState(false);
    const contentRef = useRef(null);

    useEffect(() => {
        contentRef.current.style.maxHeight = active
            ? `${contentRef.current.scrollHeight}px`
            : "0px";
    }, [contentRef, active]);

    const toogleActive = () => {
        setActive(!active);
    };

    return (
        <StyledAccordion>
            <StyledAccordionButton
                onClick={toogleActive}
                active={active}
                id={generateHtmlId("sidemenu", title)}
            >
                <p className="text-left">
                    <T>{title}</T>
                </p>
                <StyledAccordionIcon active={active} />
            </StyledAccordionButton>
            <StyledAccordionItems ref={contentRef}>
                {subItems.map((item, i) => (
                    <IFAuth key={i} roleCodes={item?.roleCodes}>
                        <Flex>
                            <StyledAccordionLink
                                to={path.join(match.url, item.path)}
                                activeClassName="active"
                                id={generateHtmlId("sidemenu_item", item.title)}
                                isActive={match => {
                                    if (!match) {
                                        return false;
                                    }
                                    setTimeout(() => setActive(true), 0); //TODO: this is preventing the user from closing the current tab.
                                    return true;
                                }}
                            >
                                <T>{item.title}</T>
                            </StyledAccordionLink>
                        </Flex>
                    </IFAuth>
                ))}
            </StyledAccordionItems>
        </StyledAccordion>
    );
}

export default Accordion;
